import type { Middleware } from 'utils/useReducerWithMiddleware'

import type * as actions from './actions'

export type MediaReducerMiddleware = Middleware<IState, Actions>

export type Actions = ReturnType<(typeof actions)[keyof typeof actions]>

export enum Action {
  START_SEEKING = 'START_SEEKING',
  TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN',
  TOGGLE_PLAY = 'TOGGLE_PLAY',
  PLAY = 'PLAY',
  PAUSE = 'PAUSE',
  SET_PLAYED = 'SET_PLAYED',
  SET_VOLUME = 'SET_VOLUME',
  DECREASE_VOLUME = 'DECREASE_VOLUME',
  INCREASE_VOLUME = 'INCREASE_VOLUME',
  SET_PLAYBACK_RATE = 'SET_PLAYBACK_RATE',
  SET_DURATION = 'SET_DURATION',
  SET_PROGRESS = 'SET_PROGRESS',
  UPDATE = 'UPDATE',
  SEEK_TO = 'SEEK_TO',
  MUTE_TOGGLE = 'MUTE_TOGGLE',
  SHOW_CC = 'SHOW_CC',
  SET_FULLSCREEN = 'SET_FULLSCREEN',
}

export interface IState {
  fullscreen?: boolean
  started: boolean
  playing?: boolean
  volume: number
  played?: number
  playedSeconds?: number
  loaded?: number
  loadedSeconds?: number
  start: number
  playbackRate: number
  seeking?: boolean
  seekStartPosition?: number
  loop?: boolean
  muted?: boolean
  showCc?: boolean
  duration: number
  currentTime?: number
  maxPlayedSeconds?: number
}

export interface IUpdateState {
  playbackRate: number
  volume: number
  start: number
  loop: boolean
}
